<template>
  <div class="p-8 rounded-lg bg-white">
    <slot />
  </div>
</template>
